import React from "react";

import Box from "./Box";

export default ({ height = 1, color, ...props }) => (
  <Box width={1} bg={color || "border"} css={{ height }} {...props} />
);
